/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useRef } from "react";
import Grid from "@mui/material/Grid";
import ButtonLoading from "../../../Button/ButtonLoading";
import uploadFieldStyle from "./uploadFieldStyle";
import { formatFilePath } from "../../../../services/mediaObjects";
import Hidden from "@mui/material/Hidden";
import { Input, LinearProgress } from "@mui/material";

type UploadFieldProps = {
  disabled?: boolean;
  fieldname: string;
  buttonText?: string;
  filePath?: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading?: boolean;
  label?: string;
};

const UploadField = ({
  isLoading = false,
  filePath = "",
  handleChange,
  label = "",
  fieldname,
  disabled = false,
  buttonText = "",
  ...rest
}: UploadFieldProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <Grid container justifyContent={"flex-end"} alignContent={"center"} alignItems={"center"} {...rest}>
      <Grid item xs={12}>
        <Grid container>
          {filePath ? (
            <Grid item xs={12} sx={uploadFieldStyle.label}>
              <Hidden smUp>{formatFilePath(filePath, 20)}</Hidden>
              <Hidden smDown>{filePath}</Hidden>
              <LinearProgress variant="indeterminate" sx={uploadFieldStyle.loadingBar} />
            </Grid>
          ) : (
            <Grid item xs={12} sx={uploadFieldStyle.chooseFile}>
              <ButtonLoading onClick={() => inputRef.current?.click()} component={"span"} isLoading={isLoading} sx={uploadFieldStyle.file} disabled={disabled}>
                {buttonText}
              </ButtonLoading>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Input
        inputRef={inputRef}
        disabled={disabled}
        name={fieldname + "-file"}
        sx={uploadFieldStyle.input}
        type="file"
        onChange={handleChange}
        data-description={label}
      />
    </Grid>
  );
};

export default UploadField;
